module.exports = "/assets/d0c18d35fc21f2106b0c843d5f56a5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MS.png
// module id = 2749
// module chunks = 0